import React from "react";
import { Pagination } from "react-bootstrap";

const AppPagination = ({
	currentPage,
	totalPages,
	totalCount,
	itemsLength,
	limit = 10,
	onPageChange,
}) => {
	if (!totalCount || totalCount <= 0) return null;

	const safeLimit = Number(limit) || 10;
	const safeTotalPages = Math.max(1, totalPages || Math.ceil(totalCount / safeLimit) || 1);
	const safeCurrentPage = Math.max(1, Math.min(currentPage || 1, safeTotalPages));
	const count = typeof itemsLength === "number" ? itemsLength : safeLimit;
	const indexOfFirstItem = (safeCurrentPage - 1) * safeLimit;
	const indexOfLastItem = indexOfFirstItem + count;

	// Smart page calculation with ellipsis
	const getPageNumbers = () => {
		if (safeTotalPages <= 7) {
			return Array.from({ length: safeTotalPages }, (_, i) => i + 1);
		}

		if (safeCurrentPage <= 4) {
			return [1, 2, 3, 4, 5, "...", safeTotalPages];
		}

		if (safeCurrentPage >= safeTotalPages - 3) {
			return [
				1,
				"...",
				safeTotalPages - 4,
				safeTotalPages - 3,
				safeTotalPages - 2,
				safeTotalPages - 1,
				safeTotalPages,
			];
		}

		return [
			1,
			"...",
			safeCurrentPage - 1,
			safeCurrentPage,
			safeCurrentPage + 1,
			"...",
			safeTotalPages,
		];
	};

	const pages = getPageNumbers();

	return (
		<div
			className="d-flex flex-wrap justify-content-between align-items-center px-4 py-3 border-top gap-2"
			style={{
				background:
					"linear-gradient(135deg, rgba(0, 120, 215, 0.04), rgba(136, 108, 255, 0.04))",
			}}
		>
			<span className="text-muted fs-13">
				Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, totalCount)} of {totalCount} entries
			</span>

			<Pagination className="pagination-sm mb-0 gap-1 align-items-center flex-wrap">
				{/* Previous */}
				<Pagination.Prev
					className="border rounded-2"
					onClick={() => onPageChange(safeCurrentPage - 1)}
					disabled={safeCurrentPage <= 1}
					title="Previous Page"
				>
					<i className="fa fa-chevron-left" />
				</Pagination.Prev>

				{/* Page Items & Ellipses */}
				{pages.map((item, idx) => {
					if (item === "...") {
						return (
							<Pagination.Ellipsis
								key={`ellipsis-${idx}`}
								disabled
								className="border-0 px-1 text-muted user-select-none"
							/>
						);
					}
					return (
						<Pagination.Item
							key={item}
							active={item === safeCurrentPage}
							onClick={() => onPageChange(item)}
							className="border rounded-2"
						>
							{item}
						</Pagination.Item>
					);
				})}

				{/* Next */}
				<Pagination.Next
					className="border rounded-2"
					onClick={() => onPageChange(safeCurrentPage + 1)}
					disabled={safeCurrentPage >= safeTotalPages}
					title="Next Page"
				>
					<i className="fa fa-chevron-right" />
				</Pagination.Next>
			</Pagination>
		</div>
	);
};

export default AppPagination;
